
import data from '../assets/data/homepage.json'
export const state = () => ({ data })
